/* eslint-disable array-callback-return */
import AddIcon from '@mui/icons-material/Add';
import { Button } from '@mui/material';
import Grid2 from '@mui/material/Unstable_Grid2/Grid2';
import { cloneDeep, concat, get, set } from 'lodash';
import React, { FC, useEffect, useState } from 'react';
import CreateForm from 'src/components/ui-component/form-component/create-form/CreateForm';
import MUIAccordionComponent from 'src/components/ui-component/mui-accordion/MUIAccordionComponent';
import MUIAlert from 'src/components/ui-component/mui-alert/MUIAlert';
import { useApplication } from 'src/context/ApplicationContext';
import DeleteRecord from 'src/lib/api/DeleteRecord';
import GetRecords from 'src/lib/api/GetRecords';
import { APIS } from 'src/lib/constants/apis';
import {
	ALS_ERLEDIGT_MARKIEREN_LABEL,
	ERLAUTERUNG_IN_KOSTEN_TITLE,
	KOSTEN_ARTEN,
	KOSTEN_POSITION,
	PARTNER_DATEN_NICHT_ERFASST,
	PLATZHALTER_TEXT,
} from 'src/lib/constants/constant';
import { FormStrucItem } from 'src/lib/types/types';
import { ForceTrue } from 'src/lib/validation/ValidationTypes';
import { checkIfSpecificKostenPositionHasComment } from 'src/pages/private/online-antrag/application-helper-function/PruefAssistenzHelperFunktion';
import { withKostenkategorieEinsatzbereichFilter } from 'src/utils/einsatzbereichHelper';
import { getFormStrucComponentTable } from 'src/utils/formStruc';
import { addIndexesToPath, checkReadOnlyInUeberarbeitung, getOptionsFromRes, removeDataKeys, removeNullDeep } from 'src/utils/helper';
import PruefAssistenz from '../../../../antrag-components/PruefAssistenz';
import ApplicationHeading from '../../../../application-heading/ApplicationHeading';
import {
	checkIfPruefAssitenzNeedsToValidate,
	getBasisDataKostenKategorie,
	getKostenErlauterung,
} from '../../../../application-helper-function/AppHelperfunctions';
import EinnahmenHinweisGlobal from '../../../global-structure/einnahmen-hinweis/content/EinnahmenHinweisGlobal';

// import schemas
import Schema from 'src/lib/paths/antrag_FULL_Paths.json';
import KostenpositionSchema from 'src/lib/paths/kostenposition_FULL_Paths.json';
const P = Schema.attributes;
const KP_P = KostenpositionSchema.attributes;

const EigenmittelAntragStartupProjekte: FC<{ kostentraeger: string; unternehmenId?: number; hasComment?: boolean }> = ({
	kostentraeger,
	unternehmenId,
	hasComment,
}) => {
	const { application, setApplicationProperty, readOnly, saveApplication } = useApplication();
	const [kostenKategorie, setKostenKategorie] = useState([]);

	const updatedReadOnly = checkReadOnlyInUeberarbeitung(application, readOnly, hasComment);

	const handleAddEigenmittel = async () => {
		let appCopy = cloneDeep(application);

		const data = getBasisDataKostenKategorie(
			appCopy,
			kostenKategorie, // All kostenkategorie for Eigenmittel, to find default Kostenkategorie id
			kostentraeger,
			unternehmenId,
			KOSTEN_POSITION.Einnahme,
			KOSTEN_ARTEN.Eigenmittel,
		);
		set(
			appCopy,
			addIndexesToPath(
				P.Foerderantrag_Kostenpositions.path,
				[`${get(appCopy, P.Foerderantrag_Kostenpositions.path, []).length}`],
				['Foerderantrag_Kostenpositions'],
			),
			{ attributes: data },
		);
		saveApplication(false, appCopy);
	};
	const handleDeleteEigenmittel = async (id: number) => {
		try {
			let appcopy = cloneDeep(application);
			const allKostenposition = get(appcopy, P.Foerderantrag_Kostenpositions.path, []);
			set(
				appcopy,
				P.Foerderantrag_Kostenpositions.path,
				allKostenposition.filter((item: any) => item.id !== id),
			);
			let res = await DeleteRecord(APIS.Kostenposition, id);
			if (res) {
				saveApplication(false, appcopy);
			}
		} catch (err: any) {
			console.error('ERROR: Deleting Personalkosten', err);
		}
	};

	// Fetch Kostenkategories
	useEffect(() => {
		const fetch = async () => {
			try {
				const filter = withKostenkategorieEinsatzbereichFilter(
					{
						Allgemein_Kostenposition: KOSTEN_POSITION.Einnahme,
						Allgemein_Kostenart_Finanzierung: KOSTEN_ARTEN.Eigenmittel,
						Allgemein_Antragsformular: { $contains: get(application, P.Allgemein_Antragsformular.path) },
						Allgemein_Aktiv: { $eq: true },
					},
					APIS.Antrag,
				);
				let res = await GetRecords(APIS.Kostenkategorie, [], filter);
				setKostenKategorie(removeNullDeep(removeDataKeys(get(res, 'data'))));
			} catch (err: any) {
				console.error('ERROR: Fetching Kostenkategories ', err);
			}
		};
		fetch();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<>
			<ApplicationHeading title='Eigen- und Drittmittel' description={PLATZHALTER_TEXT} />
			<EinnahmenHinweisGlobal kostentraeger={kostentraeger} unternehmenId={unternehmenId} />
			{get(application, P.Foerderantrag_Kostenpositions.path, []).map((ele: any, i: number) => {
				if (
					get(ele, KP_P.Allgemein_Kostenposition.path) === KOSTEN_POSITION.Einnahme &&
					get(ele, KP_P.Allgemein_Kostenart_Finanzierung.path) === KOSTEN_ARTEN.Eigenmittel &&
					get(ele, `${KP_P.Unternehmen.path}.id`) === unternehmenId
				) {
					return (
						<MUIAccordionComponent
							key={i}
							summaryTitle={`Eigen- und Drittmittel - ${get(ele, KP_P.Allgemein_Bezeichnung.path, '')}`}
							onDelete={() => handleDeleteEigenmittel(get(ele, 'id'))}
							showDeleteButton={!updatedReadOnly}
							hasComment={checkIfSpecificKostenPositionHasComment(readOnly, ele)}
						>
							<PruefAssistenz
								statusPath={addIndexesToPath(
									P.Foerderantrag_Kostenpositions.schema.attributes.Pruefung_Pruefstatus.path,
									[`${i}`],
									['Foerderantrag_Kostenpositions'],
								)}
								hinweisPath={addIndexesToPath(
									P.Foerderantrag_Kostenpositions.schema.attributes.Pruefung_Hinweis_Fuer_Antragsteller.path,
									[`${i}`],
									['Foerderantrag_Kostenpositions'],
								)}
								ueberarbeitetAmPath={addIndexesToPath(
									P.Foerderantrag_Kostenpositions.schema.attributes.Pruefung_Ueberarbeitet_Am.path,
									[`${i}`],
									['Foerderantrag_Kostenpositions'],
								)}
								erledigtPath={addIndexesToPath(
									P.Foerderantrag_Kostenpositions.schema.attributes.Pruefung_Erledigt.path,
									[`${i}`],
									['Foerderantrag_Kostenpositions'],
								)}
								formStruc={mapFormStruc(PruefAssistenzStruc(), i)}
							/>
							<MUIAlert
								title={ERLAUTERUNG_IN_KOSTEN_TITLE}
								message={getKostenErlauterung(kostenKategorie, get(ele, KP_P.Allgemein_Kostenkategorie.path))}
							/>

							<Grid2 container spacing={6}>
								<Grid2 sm={6}>
									<CreateForm
										formStruc={mapFormStruc(formStrucEigenmittel(kostenKategorie), i)}
										formValues={application}
										updateFormValuesFunc={setApplicationProperty}
										readOnly={updatedReadOnly}
										api={APIS.Kostenposition}
									/>
								</Grid2>
								<Grid2 sm={6}>
									<CreateForm
										formStruc={mapFormStruc(formStrucKostenProJahr(application, i), i)}
										formValues={application}
										updateFormValuesFunc={setApplicationProperty}
										readOnly={updatedReadOnly}
										api={APIS.Kostenposition}
									/>
								</Grid2>
							</Grid2>
						</MUIAccordionComponent>
					);
				}
			})}
			{unternehmenId ?
				<Button sx={{ mt: '2rem', maxWidth: 'fit-content' }} endIcon={<AddIcon />} onClick={handleAddEigenmittel} disabled={updatedReadOnly}>
					Eigen- und Drittmittel hinzufügen
				</Button>
			:	<MUIAlert message={PARTNER_DATEN_NICHT_ERFASST} />}
		</>
	);
};

export default EigenmittelAntragStartupProjekte;

const PruefAssistenzStruc = () => {
	return [
		{
			fields: [
				{
					...P.Foerderantrag_Kostenpositions.schema.attributes.Pruefung_Erledigt,
					label: ALS_ERLEDIGT_MARKIEREN_LABEL,
					validation: [{ validateFunction: ForceTrue }],
				},
			],
		},
	];
};
const formStrucEigenmittel = (kostenKategorie: any): FormStrucItem[] => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					...P.Foerderantrag_Kostenpositions.schema.attributes.Allgemein_Kostenkategorie,
					type: 'enumeration',
					options: getOptionsFromRes(kostenKategorie, 'Allgemein_Bezeichnung'),
				},
				P.Foerderantrag_Kostenpositions.schema.attributes.Allgemein_Bezeichnung,
			],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
	];
	return struc;
};
const formStrucKostenProJahr = (application: any, i: number): FormStrucItem[] => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					...P.Foerderantrag_Kostenpositions.schema.attributes.Allgemein_Kosten_Pro_Jahr,
					type: 'componentTable',
					disabledColumns: ['Zelle_1'],
					tableLabel: 'Einnahmen pro Jahr',
					maxLevel: get(application, P.Allgemein_Projektdauerin_Jahren.path),
					fieldProps: { Zelle_2: { format: 'currency' } },
					hideDeleteButton: true,
					sumRow: [
						{
							id: 'pinnedRow',
							Zelle_1: 'Gesamt',
							Zelle_2: get(
								application,
								addIndexesToPath(
									P.Foerderantrag_Kostenpositions.schema.attributes.Allgemein_Geplante_Gesamtsumme.path,
									[`${i}`],
									['Foerderantrag_Kostenpositions'],
								),
							),
						},
					],
				},
			],
			userProps: { columnToDivide: 1 },
		},
	];
	return struc;
};

const mapFormStruc = (formStruc: any[], index: number) => {
	let result = formStruc.map((row) => {
		return {
			...row,
			fields: (get(row, 'fields', []) as Array<any>).map((value) => {
				let pathWithoutIndex = get(value, 'path', '') as string;
				return {
					...value,
					path:
						pathWithoutIndex.slice(0, P.Foerderantrag_Kostenpositions.path.length) +
						`.${index}` +
						pathWithoutIndex.slice(P.Foerderantrag_Kostenpositions.path.length),
				};
			}),
		};
	});
	return result;
};

export const getFormStrucEigenmittelAntragStartupProjekte = (application: any, unternehmenId: number) => {
	let result: FormStrucItem[] = [];
	get(application, P.Foerderantrag_Kostenpositions.path, []).map((ele: any, i: number) => {
		if (
			get(ele, KP_P.Allgemein_Kostenposition.path) === KOSTEN_POSITION.Einnahme &&
			get(ele, KP_P.Allgemein_Kostenart_Finanzierung.path) === KOSTEN_ARTEN.Eigenmittel &&
			get(ele, `${KP_P.Unternehmen.path}.id`) === unternehmenId
		) {
			const isHinweisFieldRequired = checkIfPruefAssitenzNeedsToValidate(ele, KP_P.Pruefung_Pruefstatus.path, KP_P.Pruefung_Erledigt.path);

			const formStrucCTWithIndex = getFormStrucComponentTable(application, mapFormStruc(formStrucKostenProJahr(application, i), i));
			const formStrucWithIndex = mapFormStruc(formStrucEigenmittel([]), i);

			if (isHinweisFieldRequired) {
				result = concat(mapFormStruc(PruefAssistenzStruc(), i), formStrucWithIndex, formStrucCTWithIndex);
			} else {
				result = concat(result, formStrucWithIndex, formStrucCTWithIndex);
			}
		}
	});

	return result;
};
